/**
 * Playbook side of Concepts & Designed Type: which option lists carry a
 * design type (Run / Pass / RPO), the badge text, and the editor toggle rule.
 * The vocabulary itself lives in `lib/concept-design.ts` (shared mirror).
 */
import type { StatCategory } from '../../lib/api-types';
import {
  CONCEPT_DESIGN_LABELS,
  CONCEPT_DESIGN_TYPES,
  DESIGN_TYPE_CATEGORIES,
  isConceptDesignType,
  type ConceptDesignType,
} from '../../lib/concept-design';

export { CONCEPT_DESIGN_LABELS, CONCEPT_DESIGN_TYPES, type ConceptDesignType };

/**
 * True for the offensive-concept lists: our Offensive Concepts (Offense) and
 * the Opponent Offensive Concepts (Defense) — both are category OFF_CONCEPT.
 */
export function isDesignTypeCategory(category: StatCategory): boolean {
  return (DESIGN_TYPE_CATEGORIES as readonly string[]).includes(category);
}

/** A stored design type, or null for anything else (unset, legacy, typo). */
export function readDesignType(raw: unknown): ConceptDesignType | null {
  return isConceptDesignType(raw) ? raw : null;
}

/**
 * The 3-way toggle: tapping a type selects it; tapping the active one again
 * clears it back to "not set".
 */
export function toggleDesignType(
  current: ConceptDesignType | null,
  tapped: ConceptDesignType
): ConceptDesignType | null {
  return current === tapped ? null : tapped;
}
